<template>
  <div id="app">
    <router-view />
    <!-- 所有“最高层”浮层的挂载点 -->
    <portal-target name="global-overlays" multiple />

  </div>
</template>

<script>
import Cookies from "js-cookie"; // 确保正确导入 js-cookie
export default {
  name: "App",
  data() {
    return {
      test: "<p style='color:red'>转成</p><img src=2 onerror=alert(1)>",
      //   version: ''
    };
  },

  watch: {
    // 监听 project 和 identity 变化来重新连接 WebSocket
    // "$store.state.project": "setupWebSocket",
    // "$store.state.identity": "setupWebSocket",
  },

  created() {
    // this.test = this.mixCommon.FilterXssHtml(this.test)
    if (sessionStorage.getItem("uInfo")) {
      if (typeof sessionStorage.getItem("uInfo") === "string") {
        this.$store.commit(
          "set_uInfo",
          JSON.parse(sessionStorage.getItem("uInfo"))
        );
      } else {
        this.$store.commit("set_uInfo", sessionStorage.getItem("uInfo"));
      }
    }
    if (sessionStorage.getItem("leftMenu")) {
      if (typeof sessionStorage.getItem("leftMenu") === "string") {
        this.$store.commit(
          "set_leftMenu",
          JSON.parse(sessionStorage.getItem("leftMenu"))
        );
      } else {
        this.$store.commit("set_leftMenu", sessionStorage.getItem("leftMenu"));
      }
    }
    if (sessionStorage.getItem("menuName")) {
      if (typeof sessionStorage.getItem("menuName") === "string") {
        this.$store.commit(
          "set_menuName",
          JSON.parse(sessionStorage.getItem("menuName"))
        );
      } else {
        this.$store.commit("set_menuName", sessionStorage.getItem("menuName"));
      }
    }
    if (sessionStorage.getItem("socketInfo")) {
      if (typeof sessionStorage.getItem("socketInfo") === "string") {
        this.$store.commit(
          "set_socketInfo",
          JSON.parse(sessionStorage.getItem("socketInfo"))
        );
      } else {
        this.$store.commit(
          "set_socketInfo",
          sessionStorage.getItem("socketInfo")
        );
      }
    }
    if (sessionStorage.getItem("token")) {
      this.$store.commit("set_token", sessionStorage.getItem("token"));
    }
    if (sessionStorage.getItem("tenantInfo")) {
      this.$store.commit(
        "set_tenantInfo",
        JSON.parse(sessionStorage.getItem("tenantInfo"))
      );
    }
    if (sessionStorage.getItem("projectData")) {
      this.$store.commit(
        "set_projectData",
        JSON.parse(sessionStorage.getItem("projectData"))
      );
    }
    // 页面刷新时自动重连 WebSocket
    // this.setupWebSocket();
    // 监听来自子组件的事件
    // this.$root.$on("reconnect-websocket", this.setupWebSocket);
  },

  mounted() {
    setTimeout(() => {
      // setWaterMark('', '12')
    }, 1000);
  },

  beforeDestroy() {
    // 在组件销毁时关闭 WebSocket 连接
    this.disconnectWebSocket();
    // this.$root.$off("reconnect-websocket", this.setupWebSocket); // 移除监听器
  },

  destroyed() {
    localStorage.clear();
    // removeWatermark()
  },

  methods: {
    // 设置 WebSocket 连接
    setupWebSocket() {
      const project = Cookies.get("project") || this.$store.state.project;
      const identity = Cookies.get("identity") || this.$store.state.identity;

      if (project && identity) {
        // const wsUrl = `wss://123.232.123.238:9098/msg-center/rtc/${project}/${identity}`;
        // const wsUrl = `wss://123.232.123.238:8090/msg-center/rtc/${project}/${identity}`;

        // 如果已有 WebSocket 连接，先关闭
        if (this.ws) {
          this.ws.close();
        }

        // 创建新的 WebSocket 连接
        this.ws = new WebSocket(wsUrl);

        this.ws.onopen = () => {
          console.log("WebSocket连接已建立");
        };

        this.ws.onmessage = (event) => {
          console.log("WebSocket消息:", event.data);
        };

        this.ws.onclose = () => {
          console.log("WebSocket连接已关闭");
        };

        this.ws.onerror = (error) => {
          console.error("WebSocket错误:", error);
        };
      }
    },

    // 断开 WebSocket 连接
    disconnectWebSocket() {
      if (this.ws) {
        this.ws.close();
        console.log("WebSocket连接已关闭");
      }
    },
  },
};
</script>

<style lang="less">
.size {
  width: 100%;
  height: 100%;
}

html,
body {
  .size;
  // overflow: hidden;
  margin: 0;
  padding: 0;
}

#app {
  .size;
}
</style>